export default __webpack_public_path__ + "static/media/bat5.d005a980.jpg";